import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Crud.css";

const PratosDoDia = ({ token }) => {
  const [pratos, setPratos] = useState([]);
  const [form, setForm] = useState({ name: "", description: "" });

  useEffect(() => {
    const fetchPratos = async () => {
      try {
        const response = await axios.get("https://cardapio.olympicbarbacena.com.br/api/pratos-do-dia", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPratos(response.data);
      } catch (error) {
        console.error("Erro ao buscar pratos do dia:", error);
      }
    };
    fetchPratos();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://cardapio.olympicbarbacena.com.br/api/pratos-do-dia",
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPratos((prev) => [...prev, response.data]);
      setForm({ name: "", description: "" });
    } catch (error) {
      console.error("Erro ao salvar prato do dia:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://cardapio.olympicbarbacena.com.br/api/pratos-do-dia/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPratos((prev) => prev.filter((prato) => prato._id !== id));
    } catch (error) {
      console.error("Erro ao excluir prato do dia:", error);
    }
  };

  return (
    <div className="crud-container">
      <h2>Gerenciar Pratos do Dia</h2>
      <form onSubmit={handleSubmit} className="crud-form">
        <input
          type="text"
          placeholder="Nome do Prato"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          required
        />
        <input
          type="text"
          placeholder="Descrição"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          required
        />
        <button type="submit" className="crud-button">
          Adicionar Prato
        </button>
      </form>
      <ul className="crud-list">
        {pratos.map((prato) => (
          <li key={prato._id} className="crud-item">
            <div>
              <strong>{prato.name}</strong>
              <p>{prato.description}</p>
            </div>
            <button onClick={() => handleDelete(prato._id)} className="crud-delete-button">
              Excluir
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PratosDoDia;
